import React, { useState, useEffect } from 'react';

import { useParams } from 'react-router-dom';

import UserEditRecord from '../../components/Shared/User/UserEditRecord'

import MainBlockHeader from '../MainBlockHeader'
import MainBlockContainer from '../MainBlockContainer';

import { useRecoilValue } from 'recoil';
import { selectedUserState } from '../../states/selectedUserState';
import UserPermissions from '../../services/user.permissions.service';

import { useTranslation } from 'react-i18next';

export default function RecordView() {  
  let { userUid, recordUid } = useParams();
  const { t } = useTranslation();
  const user = useRecoilValue(selectedUserState);
  let permissions = new UserPermissions(user);

  return (
    <>              
      <MainBlockHeader header={t('recordEdit.header')} >
      </MainBlockHeader>

      <MainBlockContainer>      
        <UserEditRecord
          userUid={userUid}
          recordUid={recordUid}
          baseEditRecordUrl={`/user/records`}
        />

      </MainBlockContainer>
    </>
  );  
}

